module.exports = __webpack_public_path__ + "static/media/IMG_0053.b038b6e2.JPG";